// Rekit uses a new approach to organizing actions and reducers. That is
// putting related actions and reducers in one file. See more at:
// https://medium.com/@nate_wang/a-new-approach-for-managing-redux-actions-91c26ce8b5da

import {
  STOCK_GET_LIST_STOCK_CLEAR,
} from './constants';

export function getListStockClear() {
  return {
    type: STOCK_GET_LIST_STOCK_CLEAR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case STOCK_GET_LIST_STOCK_CLEAR:
      return {
        ...state,
        dataList: null
      };

    default:
      return state;
  }
}
